import React from 'react';
import { useViewport } from '../../hooks/useViewport';

/**
 * 按视口渲染不同内容，或根据视口添加类名
 * 用法1：<Responsive mobile={<A/>} desktop={<B/>} />
 * 用法2：<Responsive mobile={<A/>} tablet={<B/>} desktop={<C/>} />
 * 用法3：<Responsive className={styles.box}>始终显示</Responsive>（子组件内用 useViewport 判断）
 */
function Responsive({
  children,
  mobile,
  tablet,
  desktop,
  mobileOrTablet,
  className = '',
  as: Tag = 'div',
}) {
  const { isMobile, isTablet, isDesktop, isMobileOrTablet } = useViewport();

  if (mobileOrTablet !== undefined && isMobileOrTablet) {
    return mobileOrTablet;
  }
  if (mobile !== undefined && isMobile) {
    return mobile;
  }
  if (tablet !== undefined && isTablet) {
    return tablet;
  }
  if (desktop !== undefined && isDesktop) {
    return desktop;
  }
  if (children !== undefined) {
    return className ? <Tag className={className}>{children}</Tag> : children;
  }
  return null;
}

export default Responsive;
